module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!-- Modal -->\n<div class="modal fade" id="mark-as-modal" tabindex="-1" role="dialog" aria-labelledby="mark-as-modal">\n    <div class="modal-dialog modal-lg" role="document">\n        <div class="modal-content">\n            <div class="modal-header">\n                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span\n                        aria-hidden="true">&times;</span></button>\n                <h4 class="modal-title" id="mark-as-modal-label">Mark as '+
((__t=( mode ))==null?'':__t)+
'</h4>\n            </div>\n            <div class="modal-body">\n                <div class="form-group">\n                    <textarea rows="8" class="form-control" id="comment" placeholder="'+
((__t=( commentPlaceholder ))==null?'':__t)+
'"></textarea>\n                </div>\n                <div class="form-group">\n                    <input type="text" class="form-control" id="mark-as-time" placeholder="Time of '+
((__t=( mode ))==null?'':__t)+
'">\n                </div>\n                <div id="mark-as-loader" class="loader" style="height: 200px;"></div>\n            </div>\n            <div class="modal-footer">\n                <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>\n                <button type="button" class="btn btn-primary" id="go" disabled>Save</button>\n            </div>\n        </div>\n    </div>\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/documents/mark-as-form.html
// module id = 329
// module chunks = 0